import createImageIcon from './createImageIcon';
import path from './credit-card.svg';

export default createImageIcon({displayName: 'CreditCardIcon', path});



// WEBPACK FOOTER //
// ./src/common/components/icons/CreditCardIcon.js